// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___ZRr2","toggle":"styles_toggle__2G0ck","preview":"styles_preview__-gp45"};